import * as React from 'react';
import { cn } from '@/shared/lib/utils';

export const Textarea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
    function Textarea({ className, ...props }, ref) {
        return (
            <textarea
                ref={ref}
                className={cn(
                    'scrollbar-subtle min-h-[128px] w-full rounded-[24px] border border-border bg-panel px-4 py-3 text-sm leading-6 text-foreground outline-none placeholder:text-muted focus-visible:ring-2 focus-visible:ring-accent',
                    className,
                )}
                {...props}
            />
        );
    },
);